import { render, staticRenderFns } from "./holidayActFemaleRank.vue?vue&type=template&id=d48c20f0&scoped=true"
import script from "./holidayActFemaleRank.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleRank.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleRank.vue?vue&type=style&index=0&id=d48c20f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48c20f0",
  null
  
)

export default component.exports